import CalendarAndEvents from '../pages/events/CalendarAndEvents'
import ProposalsAndQuotes from '../pages/events/ProposalsAndQuotes'
import EventRecordOverview from '../pages/events/EventRecordOverview'
import ShiftsAndDocuments from '../pages/events/ShiftsAndDocuments'
import ShiftApplicationsAcknowledgements from '../pages/events/ShiftApplicationsAcknowledgements'
import PlanningDocuments from '../pages/events/PlanningDocuments'
import EMPAndTemplates from '../pages/events/EMPAndTemplates'
import EventCostsAndExpenses from '../pages/events/EventCostsAndExpenses'
import PostEventAnalysis from '../pages/events/PostEventAnalysis'
import ClientsAndAccounts from '../pages/events/ClientsAndAccounts'

export default [
  {
    id: 'calendar-and-sales',
    title: 'Calendar and Sales',
    pages: [
      {
        id: 'calendar-and-events',
        title: 'Event Calendar and Creating Events',
        summary:
          'Browse the event calendar views, read the shift-cover badges and status legend, and create a new event with its venue address.',
        component: CalendarAndEvents,
        tags: ['Events', 'Calendar', 'Add Event', 'Venue Address'],
      },
      {
        id: 'proposals-and-quotes',
        title: 'Proposals and Quotes',
        summary:
          'Track sales leads on the proposals board and build, send, and accept quotes for clients.',
        component: ProposalsAndQuotes,
        tags: ['Proposals', 'Quotes', 'Sales', 'Kanban'],
      },
    ],
  },
  {
    id: 'event-record',
    title: 'Event Record',
    pages: [
      {
        id: 'event-overview',
        title: 'Event Record Overview',
        summary:
          'Event details, statuses and cancellation, notes, tasks, SMS/email broadcast, client feedback links, duplicating events, and the read-only view.',
        component: EventRecordOverview,
        tags: [
          'Event Record',
          'Status',
          'Notes',
          'Tasks',
          'Client Feedback',
          'Basic View',
        ],
      },
      {
        id: 'shifts-and-documents',
        title: 'Shifts and Documents',
        summary:
          'Add, repeat, and assign event shifts, understand assignment checks and locked shifts, manage event documents, and upload the organiser’s participant list for ePCR bib-number lookup.',
        component: ShiftsAndDocuments,
        tags: [
          'Shifts',
          'Documents',
          'Subcontractors',
          'Number of Shifts',
          'Repeat',
          'Participants',
          'Entry List',
          'Bib Number',
        ],
      },
      {
        id: 'shift-applications-and-acknowledgement',
        title: 'Shift Applications and Acknowledgements',
        summary:
          'How advertised shifts appear to staff (including merged listings), reviewing applications, and shift acknowledgement.',
        component: ShiftApplicationsAcknowledgements,
        tags: [
          'Available Shifts',
          'Applications',
          'Acknowledgement',
          'Merged Shifts',
        ],
      },
    ],
  },
  {
    id: 'planning-and-review',
    title: 'Planning and Review',
    pages: [
      {
        id: 'planning-documents',
        title: 'The Planning Workspace',
        summary:
          'The operational, clinical, and risk planning tabs, hospital destinations, Martyn’s Law, OPELs, and Planning Intelligence.',
        component: PlanningDocuments,
        tags: [
          'Operational Plan',
          'Clinical Plan',
          'Risk Assessment',
          'Planning Intelligence',
        ],
      },
      {
        id: 'emp-and-templates',
        title: 'Event Medical Plan (EMP) and Templates',
        summary:
          'Generate, approve, and share the Event Medical Plan, and reuse EMP templates and wording suggestions.',
        component: EMPAndTemplates,
        tags: ['EMP', 'Medical Plan', 'Templates', 'Approval'],
      },
      {
        id: 'event-costs-and-expenses',
        title: 'Event Costs and Expenses',
        summary:
          'The Costs tab: staff, vehicle, and consumable cost estimates, margin against invoices, and event expense approval.',
        component: EventCostsAndExpenses,
        tags: ['Costs', 'Expenses', 'Margin'],
      },
      {
        id: 'post-event-analysis',
        title: 'Post-Event Analysis',
        summary:
          'Feedback, themes, actions and the Post Event Report: a PDF for organisers and Safety Advisory Groups with clinical, control room and day-by-day figures.',
        component: PostEventAnalysis,
        tags: ['Post-Event Analysis', 'PEA', 'Post Event Report', 'Safety Advisory Group', 'Feedback', 'Reporting'],
      },
    ],
  },
  {
    id: 'clients-and-accounts',
    title: 'Clients and Accounts',
    pages: [
      {
        id: 'clients-and-accounts',
        title: 'Clients, Engagement Letters, and the Client Portal',
        summary:
          'Client records and the Clients page, account managers, engagement letters, approving client portal accounts, and what clients see in the portal.',
        component: ClientsAndAccounts,
        tags: [
          'Clients',
          'Account Manager',
          'Engagement Letter',
          'Client Portal',
          'Pending Accounts',
        ],
      },
    ],
  },
]
